/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type { Component, JSX } from 'solid-js';

export interface WithLabelProps {
  name: string;
  label: string;
  children?: JSX.Element;
  id?: string;
}

const WithLabel: Component<WithLabelProps> = (props) => {
  const getName = () => props.name;
  const getLabel = () => props.label;

  return (
    <div class="input-group" id={props.id}>
      <label for={getName()}>
        <span>{getLabel()}</span>
      </label>
      <div class="input-focus-group">{props.children}</div>
    </div>
  );
};

export default WithLabel;
